/*
  THAANI Noka-Test: kleine globale Effekte.
  - .noka-reveal blendet beim Einscrollen ein.
  - [data-noka-parallax] verschiebt schwebende Elemente leicht gegen die
    Scrollrichtung (Faktor im Attribut, Standard 0.06).
  Beides entfaellt bei prefers-reduced-motion.
*/
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const reveal = () => {
    const items = document.querySelectorAll('.noka-reveal:not(.is-in)');
    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach((el) => el.classList.add('is-in'));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    items.forEach((el) => io.observe(el));

    // Spruenge (Anker, schnelles Scrollen) ueberspringen Elemente, ohne dass sie
    // je den Viewport schneiden. Alles oberhalb der Unterkante daher direkt zeigen.
    let frame = null;
    const sweep = () => {
      frame = null;
      const limit = window.innerHeight;
      document.querySelectorAll('.noka-reveal:not(.is-in)').forEach((el) => {
        if (el.getBoundingClientRect().top < limit) {
          el.classList.add('is-in');
          io.unobserve(el);
        }
      });
    };
    window.addEventListener('scroll', () => { if (!frame) frame = requestAnimationFrame(sweep); }, { passive: true });
  };

  const parallax = () => {
    if (reduce) return;
    const items = [...document.querySelectorAll('[data-noka-parallax]')];
    if (!items.length) return;
    let frame = null;
    const update = () => {
      frame = null;
      const vh = window.innerHeight;
      items.forEach((el) => {
        const rect = el.getBoundingClientRect();
        if (rect.bottom < -200 || rect.top > vh + 200) return;
        const factor = Number(el.dataset.nokaParallax) || 0.06;
        const offset = (rect.top + rect.height / 2 - vh / 2) * -factor;
        el.style.setProperty('--py', `${offset.toFixed(1)}px`);
      });
    };
    window.addEventListener('scroll', () => { if (!frame) frame = requestAnimationFrame(update); }, { passive: true });
    update();
  };

  // Produktkarten: Betrag der gewaehlten Packgroesse im Kaufbutton
  const cards = () => {
    const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CHF';
    const fmt = new Intl.NumberFormat('de-CH', { style: 'currency', currency });
    document.querySelectorAll('[data-noka-card-form]').forEach((form) => {
      if (form.dataset.nokaReady) return;
      form.dataset.nokaReady = '1';
      const sync = () => {
        const checked = form.querySelector('[name="quantity"]:checked');
        const target = form.querySelector('[data-card-preis]');
        if (checked && target) target.textContent = ` – ${fmt.format(Number(checked.dataset.price) / 100)}`;
      };
      form.addEventListener('change', sync);
      sync();
    });
  };

  // Splash-Videos wie die alte Startseite: Explosion einmal abspielen, ab
  // 35 % der Laufzeit tritt das Video weich gezeichnet und leiser zurueck
  // (Klasse is-fokus) und bleibt so stehen. Kein Loop. Im Hero startet der
  // Produktwechsel das Video (sections/thaani-noka-hero.liquid), hier nur
  // die uebrigen Splashes beim ersten Sichtbarwerden.
  const FOKUS_AB = 0.35;
  const splash = () => {
    const videos = [...document.querySelectorAll('.noka-splash__video')];
    videos.forEach((v) => {
      // Seitenkopf mit Schleier: Video laeuft in Schleife, ohne Weichzeichnen.
      if (v.closest('.noka-kopf__video--schleier')) return;
      v.loop = false;
      if (v.dataset.nokaSplash) return;
      v.dataset.nokaSplash = '1';
      const box = v.closest('.noka-splash');
      v.addEventListener('timeupdate', () => {
        let dauer = v.duration;
        if (!Number.isFinite(dauer) && v.seekable && v.seekable.length) dauer = v.seekable.end(v.seekable.length - 1);
        v.style.setProperty('--noka-splash-fade', Math.min(1, v.currentTime / 0.5).toFixed(2));
        if (Number.isFinite(dauer) && dauer > 0 && box) box.classList.toggle('is-fokus', v.currentTime / dauer >= FOKUS_AB);
      });
      v.addEventListener('ended', () => box && box.classList.add('is-fokus'));
    });
    if (reduce) { videos.forEach((v) => v.pause()); return; }
    if (!('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return;
        const v = e.target;
        io.unobserve(v);
        v.preload = 'auto';
        v.play().catch(() => {});
      });
    }, { threshold: 0.25 });
    videos.filter((v) => !v.closest('.noka-hero__slide')).forEach((v) => io.observe(v));
  };

  // Bogen unter einer Buehne: Farbe der folgenden Section uebernehmen, damit
  // kein fremder Streifen entsteht (Chris, 16.10., B2B).
  const curves = () => {
    document.querySelectorAll('.noka-curve').forEach((curve) => {
      const section = curve.closest('.shopify-section');
      let next = section && section.nextElementSibling;
      while (next && (!next.offsetHeight || getComputedStyle(next).display === 'none')) next = next.nextElementSibling;
      let farbe = null;
      const kandidaten = next ? [next, ...next.querySelectorAll('*')].slice(0, 40) : [];
      for (const el of kandidaten) {
        const bg = getComputedStyle(el).backgroundColor;
        if (bg && bg !== 'transparent' && !/rgba\(0, 0, 0, 0\)/.test(bg)) { farbe = bg; break; }
      }
      if (!farbe) farbe = getComputedStyle(document.body).backgroundColor;
      curve.style.color = farbe;
    });
  };

  // Seitenkopf mit mehreren Hintergrundbildern: alle data-dauer Sekunden
  // sanft weiterblenden (CSS-Transition auf is-aktiv). Bei reduzierter
  // Bewegung bleibt das erste Bild stehen.
  const wechsel = () => {
    document.querySelectorAll('.noka-kopf__video--wechsel').forEach((box) => {
      if (box.dataset.nokaWechsel) return;
      box.dataset.nokaWechsel = '1';
      const bilder = [...box.querySelectorAll('.noka-kopf__bild')];
      if (bilder.length < 2 || reduce) return;
      const ms = (parseFloat(box.dataset.dauer) || 7) * 1000;
      let i = 0;
      const timer = setInterval(() => {
        if (!box.isConnected) { clearInterval(timer); return; }
        if (document.hidden) return;
        bilder[i].classList.remove('is-aktiv');
        i = (i + 1) % bilder.length;
        bilder[i].classList.add('is-aktiv');
      }, ms);
    });
  };

  const init = () => { reveal(); parallax(); cards(); splash(); curves(); wechsel(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
